import { Toast } from "../components/notify/Notify";
import { url } from "../constants/path";
import api from "../services/api";
import { getLocalAccessToken } from "../utils/helper";

const accessToken = getLocalAccessToken();

api.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

const URL = url.cacheAction;

export const getCurrentCacheAction = (callback) => {
  api
    .get(URL)
    .then((response) => {
      callback(response.data.data);
    })
    .catch((err) => Toast("warning", err.response.data.message));
};

export const getCurrentCacheUser = (callback) => {
  api
    .get(url.cacheUser)
    .then((response) => {
      callback(response.data.data);
    })
    .catch((err) => Toast("warning", err.response.data.message));
};
